import { render, staticRenderFns } from "./CommunicationDetails.vue?vue&type=template&id=99fab294&"
import script from "./CommunicationDetails.vue?vue&type=script&lang=js&"
export * from "./CommunicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports